module.exports = __webpack_public_path__ + "img/nav-right-search-below-nissan.75a9c24f.png";